<template>
  <KikHeading
    :level="3"
    title="Don't have an account yet?"
    description="Nice to meet you!"
  >
    <template #description="{ description }">
      <div class="mb-3 text-xs font-light leading-4 text-neutral-500">
        {{ $t(description) }}
      </div>
    </template>
  </KikHeading>

  <div class="mb-6 text-base">
    <KikIcon
      icon="check"
      size="sm"
      class="mb-1 mr-2 fill-black"
    />
    {{ $t('Register quickly and securely') }}
  </div>
  <div class="absolute inset-x-0 -bottom-6 me-auto ms-auto w-[320px]">
    <div class="bg-white text-center">
      <KikButton
        class="h-[48px] min-w-[280px]"
        variant="primary"
        data-testid="login__register-btn"
        @click="navigateToRegistration"
      >
        {{ $t('To register') }}
      </KikButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useTracking } from '~/composables/custom/useTracking';

const emit = defineEmits(['startRegistration']);

const { trackStartRegistration } = useTracking();

const navigateToRegistration = () => {
  trackStartRegistration();
  emit('startRegistration');
};
</script>
